import { render, staticRenderFns } from "./PurchaseList.vue?vue&type=template&id=591f8546"
import script from "./PurchaseList.vue?vue&type=script&lang=js"
export * from "./PurchaseList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseList.vue?vue&type=style&index=0&id=591f8546&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('591f8546')) {
      api.createRecord('591f8546', component.options)
    } else {
      api.reload('591f8546', component.options)
    }
    module.hot.accept("./PurchaseList.vue?vue&type=template&id=591f8546", function () {
      api.rerender('591f8546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/purchase/views/PurchaseList.vue"
export default component.exports